module.exports = __webpack_public_path__ + "static/media/lafise-clock.5c75ad5d.svg";